import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import { useLanguage } from "./LanguageContext";

function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState("");
  const [role, setRole] = useState("patient");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { lang, toggleLang, t } = useLanguage();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await setDoc(doc(db, "users", user.uid), {
        name,
        email,
        role,
        verificationStatus: role === "patient" ? "n/a" : "pending",
        createdAt: new Date().toISOString(),
      });
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <button onClick={toggleLang} style={styles.langToggle}>
          {lang === "de" ? "EN" : "DE"}
        </button>
        <h1 style={styles.brand}>{t("appName")}</h1>
        <p style={styles.tagline}>{t("tagline")}</p>

        <form onSubmit={handleSignup} style={{ marginTop: 24 }}>
          <div style={styles.field}>
            <label style={styles.label}>{t("name")}</label>
            <input value={name} onChange={(e) => setName(e.target.value)} required style={styles.input} />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>{t("email")}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={styles.input} />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>{t("password")}</label>
            <div style={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ ...styles.input, paddingRight: 40 }}
              />
              <span onClick={() => setShowPassword(!showPassword)} style={styles.eyeIcon}>
                {showPassword ? "hide" : "show"}
              </span>
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>{t("iAm")}</label>
            <select value={role} onChange={(e) => setRole(e.target.value)} style={styles.input}>
              <option value="patient">{t("patient")}</option>
              <option value="individual">{t("individual")}</option>
              <option value="agency">{t("agency")}</option>
            </select>
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button}>{t("register")}</button>
        </form>

        <p style={styles.footerText}>
          {t("alreadyRegistered")} <Link to="/login" style={styles.link}>{t("login")}</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eef5ff 0%, #f7fbff 100%)",
    fontFamily: "'Segoe UI', sans-serif",
    padding: 20,
  },
  card: {
    background: "#ffffff",
    padding: "40px 36px",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: 400,
    position: "relative",
  },
  langToggle: {
    position: "absolute",
    top: 16,
    right: 16,
    padding: "4px 10px",
    borderRadius: 6,
    border: "1px solid #ccc",
    background: "#f5f5f5",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    color: "#333",
  },
  brand: { margin: 0, fontSize: 24, color: "#1a5fb4", textAlign: "center" },
  tagline: { textAlign: "center", color: "#555", fontSize: 14, marginTop: 6 },
  field: { marginBottom: 16 },
  label: { display: "block", fontSize: 13, color: "#333", marginBottom: 6, fontWeight: 600 },
  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 14,
    boxSizing: "border-box",
  },
  passwordWrapper: { position: "relative" },
  eyeIcon: {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    fontSize: 12,
    color: "#1a5fb4",
    fontWeight: 600,
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#1a5fb4",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 8,
  },
  error: { color: "#d32f2f", fontSize: 13, marginBottom: 8 },
  footerText: { textAlign: "center", fontSize: 13, marginTop: 20, color: "#555" },
  link: { color: "#1a5fb4", fontWeight: 600, textDecoration: "none" },
};

export default Signup;
